export enum CaseType {
  Design = 0,
  Rating = 1,
  Bin = 2,
  Erp = 3,
  Eurovent = 4
}
